module.exports = __webpack_public_path__ + "static/media/a-smarter-harvest-mobile.c5563867.jpg";